module.exports = __webpack_public_path__ + "static/media/UP_niespar.8446e3f2.svg";